import React, { useContext } from 'react';
import AppChoicesContext from '../../context/AppChoicesContext';
import CachedResponse from '../CachedResponse';

const AppChoicesProvider = ({ children }) => {
  return (
    <CachedResponse
      listEndpoint={'app-choices'}
      render={appChoices => <AppChoicesContext.Provider value={appChoices}>{children}</AppChoicesContext.Provider>}
    />
  );
};

export default AppChoicesProvider;
